const r=(r,e=0,t=1)=>{if(r<0)throw new Error("`length` must be a positive integer");return Array.from({length:r},((r,n)=>e+n*t))};export{r as createSequence};
